import { apiClient } from "../config";

async function updateSurveyFields(id: string | number, data: any) {
  const res = await apiClient.put(`/admin/survey-and-polls/${id}/fields`, data);
  return res.data;
}

export default updateSurveyFields;
